let bundleBuilder = {};

bundleBuilder = {
  previewImage: '',
  originalTotalPrice: '',
  discountedTotalPrice: '',
  products: {
    sheetSet: {
      item: "sheetSet",
      selected: false,
      variantId: '',
      title: 'Sheet Set',
      productTitle: '',
      url: '',
      imgSrc: '',
      imgSrcSide: '',
      imgSrcFront: '',
      imgSrcSideQuilt: '',
      imgSrcFrontQuilt: '',
      comparePrice: '',
      price: '',
      size: '',
      color: '',
      quantity: 1,
      setIncludes: 'Set includes: Fitted Sheet, Flat Sheet, Pillowcase(s)'
    },
    quiltCoverSet: {
      item: "quiltCoverSet",
      selected: false,
      variantId: '',
      title: 'Quilt Cover Set',
      productTitle: '',
      url: '',
      imgSrc: '',
      imgSrcSide: '',
      imgSrcFront: '',
      comparePrice: '',
      price: '',
      size: '',
      color: '',
      quantity: 1,
      setIncludes: 'Set includes: Quilt Cover, Pillowcase(s)'
    },
    extra: {
      item: "extra",
      selected: false,
      variantId: '',
      title: 'Extra',
      productTitle: '',
      url: '',
      imgSrc: '',
      imgSrcSide: '',
      imgSrcFront: '',
      comparePrice: '',
      price: '',
      size: '',
      color: '',
      quantity: 1,
      setIncludes: ''
    }
  }
}

let sheetSet = bundleBuilder.products.sheetSet;
let quiltCoverSet = bundleBuilder.products.quiltCoverSet;
let extra = bundleBuilder.products.extra;
let bundleItemsWrapper = $('#set4Content .bundleItemsWrapper');

// Functions on document ready
$(function() {
  $('.itemsImagesSliderWrap').slick({
    arrows: true,
    dots: true
  });

  if ($(this).width() <= 768) { 
    let element = document.querySelector('.bundleHeadWrap');
    element.style.width = element.scrollWidth+'px';
  }
});

// Accordian title click events
$('.bundleHead .set').click(function(e) {

  let activeSet = $(this).parent().find('.activeSet');
  let prevSiblings;
  let activeId = activeSet.attr('id');
  let newId = $(this).attr('id');
  let prevComplete = true;
  let previewImage;
  let originalPrice = 0;
  let discountedPrice = 0;
  let discount = 0;

  originalPrice = (+sheetSet.comparePrice.replace('$', '')+ +quiltCoverSet.comparePrice.replace('$', '')+ (+extra.quantity * +extra.comparePrice.replace('$', ''))).toFixed(2);
  discountedPrice = (+sheetSet.price.replace('$', '')+ +quiltCoverSet.price.replace('$', '')+ (+extra.quantity * +extra.price.replace('$', ''))).toFixed(2);
  discount = (originalPrice - discountedPrice).toFixed(2);

  if (!$(this).hasClass('activeSet')) {
    
    prevSiblings = $(this).prevAll();
    prevSiblings.each(function(index, value) {
      
      if (value.dataset.complete == 'yes') {
        $(value).addClass('selectedSet');
      } else {
        prevComplete = false;
      }

    });
    
    if((prevComplete && prevSiblings.length <= 1) || (prevSiblings[0].dataset.complete == 'yes' && prevSiblings.length == 2) || (prevSiblings[1] && prevSiblings[1].dataset.complete == 'yes' && prevSiblings.length == 3)) { 

      e.preventDefault();

      if($(this).attr('id') == 'set4') {

        $('.originalPrice').html(`$${originalPrice}`);
        $('.discountedPrice').html(`$${discountedPrice}`);
        $('.discount').html(`-$${discount}`);
        $('.savings span').html(`${(discount*100/originalPrice).toFixed(2)}%`);

      }

      activeSet.removeClass('activeSet');
      $(this).addClass('activeSet');
      $('.bundleContent .setContent').each( function() {
  
        if ($(this).data('id') == activeId) {
          
          $(this).addClass('hidden');
  
        } else if ($(this).data('id') == newId) {
  
          $(this).removeClass('hidden');
          previewImage = $(this).find('select option:selected').data('src');
  
        }
  
      });

    }

  }

});

// Size radio change events
$('.bundleContent .sizeOptions input[type=radio]').change(function() {

  let selectedSize = $(this).val();

  updateInclusions.call(this, selectedSize);
  showColorOptions.call(this);
  updateSelect.call(this, selectedSize);

});

// Color radio change events
$('.bundleContent .colorOptions input[type=radio]').change(function() {

  $(this).parents('.contentOptions').find('.colorOptions .border-black').not($(this).parent()).removeClass('border-black');

  let selectedColor = $(this).val();

  changeBorderColor.call(this);
  updateColor.call(this, selectedColor);
  updateSelect.call(this, selectedColor);

});

// Previous button click events
$('body').on('click', '.prevBtn', function(e) {
  
  e.preventDefault();

  let dataId = $(this).parents('.setContent').data('id');
 
  if($(`.bundleHead #${dataId}`).data('complete') == 'yes') {
    $(`.bundleHead #${dataId}`).addClass('selectedSet');
  }
  $(`.bundleHead #${dataId}`).removeClass('activeSet');
  $(`.bundleHead #${dataId}`).prev().addClass('activeSet');

  $(this).parents('.setContent').addClass('hidden').prev().removeClass('hidden');

});

// Next button click events
$('body').on('click', '.nxtBtn', function(e) {
  
  e.preventDefault();

  let dataId = $(this).parents('.setContent').data('id');
  let previewImage = $(this).parents('.setContent').next().find('select option:selected').data('src');
  let originalPrice = 0;
  let discountedPrice = 0;
  let discount = 0;

  originalPrice = (+sheetSet.comparePrice.replace('$', '')+ +quiltCoverSet.comparePrice.replace('$', '')+ (+extra.quantity * +extra.comparePrice.replace('$', ''))).toFixed(2);
  discountedPrice = (+sheetSet.price.replace('$', '')+ +quiltCoverSet.price.replace('$', '')+ (+extra.quantity * +extra.price.replace('$', ''))).toFixed(2);
  discount = (originalPrice - discountedPrice).toFixed(2);

  if($(`.bundleHead #${dataId}`).attr('data-complete') == 'no') {
    if(dataId == 'set1' || dataId == 'set2') {
      $(this).parents('.contentWrap').find('.selectionMsg').removeClass('hidden');
      return;
    }
  } else {
    if(dataId == 'set1' || dataId == 'set2') {
      $(this).parents('.contentWrap').find('.selectionMsg').addClass('hidden');
    }
    $(`.bundleHead #${dataId}`).addClass('selectedSet');
  }
  $(`.bundleHead #${dataId}`).removeClass('activeSet');

  if($(`.bundleHead #${dataId}`).next().attr('id') == 'set4') {

    $('.originalPrice').html(`$${originalPrice}`);
    $('.discountedPrice').html(`$${discountedPrice}`);
    $('.discount').html(`-$${discount}`);
    $('.savings span').html(`${(discount*100/originalPrice).toFixed(2)}%`);

  }

  $(`.bundleHead #${dataId}`).next().addClass('activeSet');
  $(this).parents('.setContent').addClass('hidden').next().removeClass('hidden');

});

// Quilt cover and Pillowcase click events(2nd and 3rd step)
$('.extraHeading label, .quiltCoverHeading label').click(function() {

  let prdctParent = $(this).parents('.productSet');
  let prdctOptions = prdctParent.parents('.contentStyles').prev().find(`.productSet[data-tab-index="${prdctParent.data('tab-index')}"]`);

  if($(this).prev().prop('checked') == false) {

    prdctParent.parents('.contentStyles').prev().find('.productSet').not(prdctOptions).addClass('hidden');
    prdctOptions.removeClass('hidden');
    prdctOptions.find('.quiltCoverContent, .extraContent').removeClass('hidden');
    prdctParent.siblings().find('input[type=checkbox]').prop('checked', false);

  } else {

    prdctOptions.addClass('hidden');
    
  }

});

// Quantity plus/minus
$('.qplus').click(function () {
  let qtyField = $(this).prev();
  let dataId = $(this).parents('.setContent').data('id');

  qtyField.val(+qtyField.val() + 1);
  extra.quantity = +qtyField.val();

  if ($(this).parents('.colorWrapper').find('.colorOptions input:checked').length > 0) {
    updateSummary(extra, dataId);
  }
});
$('.qminus').click(function () {
  let qtyField = $(this).next();
  let dataId = $(this).parents('.setContent').data('id');

  if (qtyField.val() > 1){
    qtyField.val(+qtyField.val() - 1);
    extra.quantity = +qtyField.val();

    if ($(this).parents('.colorWrapper').find('.colorOptions input:checked').length > 0) {
      updateSummary(extra, dataId);
    }
  }  
});

// Edit product(4th step)
$('body').on('click', '.bundleItemWrap .itemInfo .edit a', function(e) {

  e.preventDefault();

  let bundleItem = $(this).parents('.bundleItemWrap').data('item');
  let bundleItemSet = $(this).parents('.bundleItemWrap').data('set');
  let previewImage = $(this).parents('.bundleItemWrap').find('.itemImage img').attr('src');

  if (bundleItem.indexOf('quilt') != -1) {

    $(`input#set2_${bundleItem}_heading`).prop('checked', true);
    $(`input#set2_${bundleItem}_heading`).parent().next().removeClass('hidden');
    
    // Display relevant product and hide others on step 2
    $(`input[id^=set2_quilt]`).each(function() {

      if($(this).attr('id') != `set2_${bundleItem}_heading`) {

        $(this).prop('checked', false);
        $(this).parent().next().addClass('hidden');

      }

    });

  } else if (bundleItem.indexOf('extra') != -1) {

    $(`input#set3_${bundleItem}_heading`).prop('checked', true);
    $(`input#set3_${bundleItem}_heading`).parent().next().removeClass('hidden');
    
    // Display relevant product and hide others on step 3
    $(`input[id^=set3_]`).each(function() {

      if($(this).attr('id') != `set3_${bundleItem}_heading`) {

        $(this).prop('checked', false);
        $(this).parent().next().addClass('hidden');

      }

    });

  }

  $(`.bundleHead span#${bundleItemSet}`).click();

});

// Add to cart
$('.bundleAddToCart .bundleCart').click(function() {

  let checkout = false;
  let sidecart = true;
  $(this).append('<div class="loader"><div class="loading"></div></div>');
  $(this).find('.loader').css('display', 'flex');
  addToCart.call(this, checkout, sidecart);

});

// Checkout
$('.bundleAddToCart .bundleCheckout').click(function() {

  let checkout = true;
  let sidecart = false;
  $(this).append('<div class="loader"><div class="loading"></div></div>');
  $(this).find('.loader').css('display', 'flex');
  addToCart.call(this, checkout, sidecart);

});

function addToCart(checkout, sidecart) {

  let bundleItems = [];
  
  let sheetSetProduct = {id: '', quantity: sheetSet.quantity, properties: {'Bundle': 'Bamboo Bundle Product', 'Inclusions': sheetSet.setIncludes, 'Product': 'sheetset'}};
  let quiltCoverSetProduct = {id: '', quantity: quiltCoverSet.quantity, properties: {'Bundle': 'Bamboo Bundle Product', 'Inclusions': quiltCoverSet.setIncludes, 'Product': 'quiltcover', 'Product Index': quiltCoverSet.productIndex}};
  let extraProduct = {id: '', quantity: extra.quantity, properties: {'Bundle': 'Bamboo Bundle Product', 'Product': 'extra', 'Product Index': extra.productIndex}};

  //let sheetSetProduct = {id: '', quantity: sheetSet.quantity, properties: {'_Bundle': 'Bamboo Bundle Product', '_Inclusions': sheetSet.setIncludes, '_Product': 'sheetset'}};
  //let quiltCoverSetProduct = {id: '', quantity: quiltCoverSet.quantity, properties: {'_Bundle': 'Bamboo Bundle Product', '_Inclusions': quiltCoverSet.setIncludes, '_Product': 'quiltcover', '_Product Index': quiltCoverSet.productIndex}};
  //let extraProduct = {id: '', quantity: extra.quantity, properties: {'_Bundle': 'Bamboo Bundle Product', '_Product': 'extra', '_Product Index': extra.productIndex}};

  
  if (extra.variantId) {
    extraProduct.id = extra.variantId;
    bundleItems.push(extraProduct);
  }
  if (quiltCoverSet.variantId && quiltCoverSet.selected) {
    quiltCoverSetProduct.id = quiltCoverSet.variantId;
    bundleItems.push(quiltCoverSetProduct);
  }
  if (sheetSet.variantId) {
    sheetSetProduct.id = sheetSet.variantId;
    bundleItems.push(sheetSetProduct);
  }

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      items: bundleItems
    })
  })
  .then(response => {
    return response.json();
  }) 
  .then(data => {
    if(data.status === 422) {
      alert(data.description);
      $('button .loader').remove();
      return;
    }
    if(sidecart) {
      ajaxSubmitCart();
    }
    if (checkout) {
      window.location.href = "/checkout";
    }
    return data;
  })
  .catch((error) => {
    console.error('Error:', error);
  });

}

function ajaxSubmitCart() {
  $cart = $("#cart");
  $.ajax({
    url: '/cart.js',
    dataType: 'json',
    type: 'get',
    success: function (data) {
      window.theme.refreshCart(data);
      $('.sidecartBundleImages').slick({
        arrows: false,
        dots: true
      });
      $('.bundleAddToCart').find('.loader').remove();
      $("body").addClass("cart-popup-open");
    }
  });
}

function updateInclusions(size) {
  
  if (size == 'Double' || size == 'King' || size == 'Queen' || size == 'Super King') {

    let svgDoublePillow = '<svg width="30" height="25" viewBox="0 0 30 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M25.3077 13.1785C25.6294 13.046 25.7829 12.6777 25.6504 12.3559C25.5179 12.0341 25.1496 11.8807 24.8278 12.0132C23.8684 12.4083 22.4292 13.2377 21.1567 14.466C19.8834 15.6951 18.7342 17.3665 18.4573 19.4436C18.4113 19.7886 18.6536 20.1055 18.9985 20.1515C19.3435 20.1975 19.6604 19.9551 19.7064 19.6102C19.9335 17.9068 20.8846 16.4802 22.0319 15.3727C23.1801 14.2643 24.4818 13.5185 25.3077 13.1785Z" fill="#4B6D78"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M14.0794 5.66313C14.3663 5.93362 14.5849 6.25112 14.7404 6.5463C16.9001 6.28509 19.2529 6.7476 21.317 7.42072C23.4165 8.10539 25.2812 9.02925 26.446 9.72501C26.9485 9.63714 27.6137 9.58532 28.2103 9.69138C28.5632 9.75411 28.952 9.88236 29.2626 10.1478C29.5972 10.4338 29.7934 10.8398 29.7934 11.3357C29.7934 12.6441 29.0649 13.5036 28.4926 13.9158C28.1658 16.3297 27.0352 18.357 25.7594 19.911C24.6146 21.3055 23.3331 22.3436 22.3525 22.9637C22.4273 23.3428 22.4301 23.775 22.3315 24.1692C22.2518 24.4882 22.0942 24.8281 21.8058 25.0918C21.5065 25.3654 21.1141 25.5129 20.657 25.5129C19.9921 25.5129 19.3528 25.2417 18.8595 24.9549C18.4715 24.7293 18.1321 24.4695 17.8846 24.2498C15.4395 24.1936 13.0931 23.3298 11.1586 22.2869C9.23732 21.2511 7.67889 20.0153 6.7761 19.1373C6.16875 18.9379 5.69905 18.6744 5.39139 18.3243C5.03037 17.9136 4.9377 17.4343 5.03769 16.9811C5.1296 16.5644 5.37428 16.2047 5.62179 15.9284C5.79944 15.7301 5.99912 15.5519 6.19597 15.4008C6.39638 13.7189 7.18098 12.1232 8.06042 10.8181C8.87734 9.60587 9.80472 8.6021 10.5091 7.95915C10.4403 7.56485 10.4136 7.08061 10.5098 6.61599C10.5774 6.28999 10.7118 5.94387 10.9642 5.65053C11.2238 5.3488 11.5803 5.13625 12.0271 5.04689C12.9056 4.87118 13.6032 5.21412 14.0794 5.66313ZM12.2742 6.28261C12.6559 6.20628 12.956 6.33592 13.2149 6.58003C13.4901 6.83955 13.6781 7.1988 13.7582 7.43928C13.857 7.73558 14.1579 7.91481 14.4655 7.86053C16.4596 7.50863 18.7855 7.92066 20.9263 8.61882C23.0569 9.31362 24.9331 10.2682 25.9962 10.9263C26.136 11.0128 26.3041 11.0413 26.4645 11.0056C26.8948 10.91 27.5126 10.8473 27.9897 10.9321C28.2276 10.9744 28.3704 11.0431 28.4438 11.1058C28.4931 11.1479 28.5332 11.2014 28.5332 11.3357C28.5332 12.2949 27.8899 12.8431 27.6213 12.9774C27.429 13.0736 27.299 13.2612 27.2765 13.475C27.0408 15.7136 26.0075 17.6228 24.7854 19.1114C23.5609 20.603 22.1735 21.6392 21.2961 22.1266C21.0012 22.2905 20.8877 22.6575 21.0385 22.9592C21.1266 23.1353 21.1919 23.5321 21.109 23.8636C21.0706 24.0172 21.0115 24.1105 20.9554 24.1618C20.9101 24.2032 20.83 24.2527 20.657 24.2527C20.3136 24.2527 19.9028 24.1038 19.4929 23.8655C19.092 23.6324 18.7567 23.3516 18.5821 23.177C18.464 23.0589 18.3037 22.9925 18.1366 22.9925C15.8834 22.9925 13.6518 22.1993 11.7566 21.1776C9.8636 20.1571 8.35333 18.934 7.55565 18.1363C7.48192 18.0625 7.39103 18.0082 7.29115 17.9783C6.71274 17.8047 6.44796 17.6176 6.33795 17.4924C6.25592 17.3991 6.25014 17.3349 6.2683 17.2525C6.29453 17.1336 6.38459 16.9656 6.56043 16.7693C6.72999 16.58 6.94319 16.4049 7.14456 16.2706C7.30566 16.1632 7.40844 15.9877 7.42329 15.7947C7.53758 14.3088 8.23553 12.8133 9.10548 11.5224C9.97188 10.2367 10.972 9.20836 11.6127 8.66618C11.8018 8.50617 11.8796 8.25019 11.8116 8.01201C11.7239 7.70516 11.6662 7.24652 11.7438 6.87162C11.7813 6.69091 11.8437 6.5605 11.9194 6.4725C11.9879 6.39289 12.0909 6.31927 12.2742 6.28261Z" fill="#4B6D78"></path><path d="M7.5 17.5L3 14.5L9.5 4L23 5.5L24 7L23 10L18 17L13 18.5L7.5 17.5Z" fill="white"></path><path d="M20.4109 8.42201C20.7327 8.28951 20.8862 7.92124 20.7537 7.59946C20.6212 7.27768 20.2529 7.12423 19.9311 7.25673C18.9717 7.65179 17.5324 8.48123 16.26 9.70951C14.9867 10.9386 13.8375 12.61 13.5605 14.6872C13.5145 15.0321 13.7569 15.349 14.1018 15.395C14.4468 15.441 14.7637 15.1987 14.8097 14.8537C15.0368 13.1503 15.9879 11.7237 17.1352 10.6162C18.2834 9.50786 19.5851 8.76206 20.4109 8.42201Z" fill="#4B6D78"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M9.18266 0.906662C9.46953 1.17715 9.68821 1.49465 9.84367 1.78983C12.0034 1.52863 14.3562 1.99113 16.4203 2.66425C18.5198 3.34892 20.3845 4.27279 21.5493 4.96854C22.0518 4.88067 22.717 4.82885 23.3136 4.93491C23.6664 4.99764 24.0552 5.12589 24.3658 5.39135C24.7005 5.67737 24.8967 6.08334 24.8967 6.57919C24.8967 7.88765 24.1682 8.74716 23.5958 9.15936C23.269 11.5732 22.1385 13.6005 20.8627 15.1545C19.7179 16.549 18.4364 17.5871 17.4557 18.2072C17.5305 18.5863 17.5334 19.0186 17.4348 19.4127C17.3551 19.7317 17.1975 20.0716 16.909 20.3354C16.6098 20.609 16.2174 20.7564 15.7602 20.7564C15.0954 20.7564 14.4561 20.4852 13.9628 20.1985C13.5748 19.9728 13.2353 19.713 12.9878 19.4933C10.5428 19.4371 8.19636 18.5733 6.26189 17.5304C4.34059 16.4947 2.78216 15.2588 1.87937 14.3808C1.27202 14.1815 0.802325 13.9179 0.494658 13.5679C0.133644 13.1571 0.0409741 12.6779 0.140959 12.2246C0.232869 11.808 0.477552 11.4483 0.72506 11.172C0.902711 10.9737 1.10239 10.7955 1.29924 10.6444C1.49965 8.96247 2.28426 7.36672 3.16369 6.06167C3.98061 4.8494 4.908 3.84563 5.6124 3.20268C5.54355 2.80838 5.51685 2.32414 5.6131 1.85952C5.68063 1.53352 5.81505 1.1874 6.06747 0.894062C6.32711 0.592328 6.68353 0.379779 7.13034 0.290416C8.00888 0.114708 8.70644 0.457648 9.18266 0.906662ZM7.37749 1.52614C7.75914 1.44981 8.05924 1.57945 8.31814 1.82356C8.59338 2.08308 8.78134 2.44233 8.86149 2.68281C8.96026 2.97911 9.26118 3.15834 9.56876 3.10406C11.5629 2.75216 13.8887 3.16419 16.0296 3.86235C18.1601 4.55715 20.0364 5.51171 21.0995 6.16979C21.2393 6.25633 21.4073 6.2848 21.5678 6.24914C21.9981 6.15353 22.6159 6.09083 23.093 6.17565C23.3308 6.21794 23.4737 6.2866 23.5471 6.34931C23.5964 6.39147 23.6365 6.44494 23.6365 6.57919C23.6365 7.53847 22.9932 8.08664 22.7246 8.22096C22.5323 8.31712 22.4022 8.50472 22.3797 8.71857C22.1441 10.9572 21.1108 12.8663 19.8887 14.3549C18.6641 15.8465 17.2768 16.8827 16.3994 17.3702C16.1045 17.534 15.9909 17.901 16.1418 18.2027C16.2299 18.3789 16.2951 18.7756 16.2122 19.1071C16.1738 19.2607 16.1148 19.354 16.0587 19.4053C16.0134 19.4467 15.9332 19.4962 15.7602 19.4962C15.4169 19.4962 15.0061 19.3473 14.5962 19.109C14.1953 18.8759 13.86 18.5952 13.6854 18.4206C13.5672 18.3024 13.407 18.236 13.2398 18.236C10.9867 18.236 8.75507 17.4429 6.8599 16.4212C4.96687 15.4006 3.4566 14.1775 2.65892 13.3798C2.58519 13.306 2.49431 13.2518 2.39442 13.2218C1.81601 13.0483 1.55123 12.8611 1.44122 12.7359C1.35919 12.6426 1.35341 12.5784 1.37157 12.4961C1.3978 12.3771 1.48786 12.2091 1.6637 12.0128C1.83326 11.8236 2.04646 11.6484 2.24783 11.5142C2.40893 11.4068 2.51171 11.2313 2.52656 11.0382C2.64086 9.55234 3.3388 8.05688 4.20875 6.76591C5.07516 5.48019 6.07525 4.45189 6.71601 3.90971C6.90512 3.7497 6.98292 3.49372 6.91484 3.25554C6.82714 2.94869 6.76943 2.49005 6.84709 2.11515C6.88453 1.93444 6.94697 1.80403 7.0227 1.71603C7.0912 1.63642 7.19421 1.5628 7.37749 1.52614Z" fill="#4B6D78"></path></svg>';
    $(this).parents('.sizeWrapper').next().find('.incSpan:last-child .num').html('&nbsp;(2)');
    $(this).parents('.sizeWrapper').next().find('.incSpan:last-child .svgImg').html(svgDoublePillow);
 
  } else {
    
    let svgSinglePillow = '<svg width="25" height="25" viewBox="0 0 25 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.18266 0.906692C9.46953 1.17718 9.68821 1.49468 9.84367 1.78986C12.0034 1.52866 14.3562 1.99116 16.4203 2.66428C18.5198 3.34895 20.3845 4.27282 21.5493 4.96857C22.0518 4.8807 22.717 4.82888 23.3136 4.93494C23.6664 4.99767 24.0552 5.12592 24.3658 5.39138C24.7005 5.6774 24.8967 6.08337 24.8967 6.57922C24.8967 7.88768 24.1682 8.74719 23.5958 9.15939C23.269 11.5733 22.1385 13.6005 20.8627 15.1546C19.7179 16.5491 18.4364 17.5871 17.4557 18.2073C17.5305 18.5864 17.5334 19.0186 17.4348 19.4128C17.3551 19.7317 17.1975 20.0716 16.909 20.3354C16.6098 20.609 16.2174 20.7564 15.7602 20.7564C15.0954 20.7564 14.4561 20.4853 13.9628 20.1985C13.5748 19.9729 13.2353 19.713 12.9878 19.4933C10.5428 19.4372 8.19636 18.5733 6.26189 17.5305C4.34059 16.4947 2.78216 15.2589 1.87937 14.3809C1.27202 14.1815 0.802325 13.918 0.494658 13.5679C0.133644 13.1571 0.0409741 12.6779 0.140959 12.2246C0.232869 11.808 0.477552 11.4483 0.72506 11.172C0.902711 10.9737 1.10239 10.7955 1.29924 10.6444C1.49965 8.9625 2.28426 7.36676 3.16369 6.0617C3.98061 4.84943 4.908 3.84566 5.6124 3.20272C5.54355 2.80841 5.51685 2.32417 5.6131 1.85955C5.68063 1.53355 5.81505 1.18744 6.06747 0.894093C6.32711 0.592359 6.68353 0.379809 7.13034 0.290446C8.00888 0.114738 8.70644 0.457678 9.18266 0.906692ZM7.37749 1.52617C7.75914 1.44984 8.05924 1.57948 8.31814 1.82359C8.59338 2.08311 8.78134 2.44237 8.86149 2.68284C8.96026 2.97914 9.26118 3.15837 9.56876 3.10409C11.5629 2.75219 13.8887 3.16422 16.0296 3.86238C18.1601 4.55718 20.0364 5.51174 21.0995 6.16983C21.2393 6.25636 21.4073 6.28483 21.5678 6.24917C21.9981 6.15356 22.6159 6.09086 23.093 6.17568C23.3308 6.21797 23.4737 6.28663 23.5471 6.34935C23.5964 6.3915 23.6365 6.44497 23.6365 6.57922C23.6365 7.5385 22.9932 8.08667 22.7246 8.22099C22.5323 8.31715 22.4022 8.50476 22.3797 8.7186C22.1441 10.9572 21.1108 12.8663 19.8887 14.3549C18.6641 15.8466 17.2768 16.8827 16.3994 17.3702C16.1045 17.534 15.9909 17.901 16.1418 18.2028C16.2299 18.3789 16.2951 18.7756 16.2122 19.1071C16.1738 19.2607 16.1148 19.354 16.0587 19.4053C16.0134 19.4468 15.9332 19.4962 15.7602 19.4962C15.4169 19.4962 15.0061 19.3473 14.5962 19.109C14.1953 18.8759 13.86 18.5952 13.6854 18.4206C13.5672 18.3024 13.407 18.236 13.2398 18.236C10.9867 18.236 8.75507 17.4429 6.8599 16.4212C4.96687 15.4007 3.4566 14.1775 2.65892 13.3798C2.58519 13.3061 2.49431 13.2518 2.39442 13.2218C1.81601 13.0483 1.55123 12.8611 1.44122 12.736C1.35919 12.6426 1.35341 12.5784 1.37157 12.4961C1.3978 12.3772 1.48786 12.2092 1.6637 12.0129C1.83326 11.8236 2.04646 11.6484 2.24783 11.5142C2.40893 11.4068 2.51171 11.2313 2.52656 11.0382C2.64086 9.55237 3.3388 8.05691 4.20875 6.76594C5.07516 5.48022 6.07525 4.45192 6.71601 3.90974C6.90512 3.74973 6.98292 3.49375 6.91484 3.25557C6.82714 2.94872 6.76943 2.49009 6.84709 2.11518C6.88453 1.93447 6.94697 1.80406 7.0227 1.71606C7.0912 1.63645 7.19421 1.56283 7.37749 1.52617ZM20.4109 8.42204C20.7327 8.28954 20.8862 7.92127 20.7537 7.59949C20.6212 7.27771 20.2529 7.12426 19.9311 7.25676C18.9717 7.65182 17.5324 8.48127 16.26 9.70954C14.9867 10.9387 13.8375 12.61 13.5605 14.6872C13.5145 15.0321 13.7569 15.3491 14.1018 15.395C14.4468 15.441 14.7637 15.1987 14.8097 14.8538C15.0368 13.1503 15.9879 11.7237 17.1352 10.6162C18.2834 9.50789 19.5851 8.76209 20.4109 8.42204Z" fill="#4B6D78"/></svg>';
    $(this).parents('.sizeWrapper').next().find('.incSpan:last-child .num').html('&nbsp;(1)');
    $(this).parents('.sizeWrapper').next().find('.incSpan:last-child .svgImg').html(svgSinglePillow);

  }

}

function showColorOptions() {

  let whatsIncludedWrapper = $(this).parents('.productSet').find('.whatsIncludedWrapper');
  let colorWrapper = $(this).parents('.sizeWrapper').siblings('.colorWrapper');

  whatsIncludedWrapper.removeClass('hidden');
  colorWrapper.find('.colorOptions').removeClass('hidden');
  colorWrapper.find('.colorViewInfo .selectColor').removeClass('hidden');
  colorWrapper.find('.colorViewInfo .selectSize').addClass('hidden');

} 

function updateSelect(option) {
  
  let selectedVariant;
  
  if($(this).attr('name').includes('Size')) {

    let size = option;
    let colorWrapper = $(this).parents('.sizeWrapper').siblings('.colorWrapper');
    let color;
    let variantOptions = $(this).parents('.sizeWrapper').prev().find('select option');
    let dataId = $(this).parents('.setContent').data('id');

    if (colorWrapper.find('input[type=radio]:checked').length > 0) {
      color = colorWrapper.find('input[type=radio]:checked').val();
    } else {
      color = colorWrapper.find('input[type=radio]:first').val();
    }
    
    selectedVariant = size.concat(' / ', color);

    variantOptions.each(function() {

      if($(this).data('title') == selectedVariant && $(this).parents('.setContent').attr('id') == 'set1Content') {

        sheetSet.variantId  = $(this).val();
        sheetSet.imgSrc  = $(this).data('src');
        sheetSet.imgSrcSide  = $(this).data('src-side');
        sheetSet.imgSrcFront  = $(this).data('src-front');
        sheetSet.imgSrcSideQuilt  = $(this).data('src-side-quilt');
        sheetSet.imgSrcFrontQuilt  = $(this).data('src-front-quilt');
        sheetSet.productTitle  = $(this).data('product-title');
        sheetSet.url  = $(this).data('url');
        sheetSet.comparePrice  = $(this).data('compare-price');
        sheetSet.price  = $(this).data('price');
        sheetSet.size  = size;
        $(this).prop("selected", true);

        if(size == 'Queen' || size == 'King' || size == 'Double') {
          sheetSet.setIncludes = 'Set includes: Fitted Sheet(1), Flat Sheet(1), Pillowcase(2)';
        }else{
          sheetSet.setIncludes = 'Set includes: Fitted Sheet(1), Flat Sheet(1), Pillowcase(1)';
        }

        if(sheetSet.selected) {
          updateSummary(sheetSet, dataId);
        }

        if (sheetSet.size && sheetSet.color) {
          $(this).parents('.contentWrap').find('a.nxtBtn').addClass('enabled');
        }

      } else if($(this).data('title') == selectedVariant && $(this).parents('.setContent').attr('id') == 'set2Content') {

        quiltCoverSet.variantId  = $(this).val();
        quiltCoverSet.imgSrc  = $(this).data('src');
        quiltCoverSet.imgSrcSide  = $(this).data('src-side');
        quiltCoverSet.imgSrcFront  = $(this).data('src-front');
        quiltCoverSet.productTitle  = $(this).data('product-title');
        quiltCoverSet.url  = $(this).data('url');
        quiltCoverSet.comparePrice  = $(this).data('compare-price');
        quiltCoverSet.price  = $(this).data('price');
        quiltCoverSet.size  = size;
        $(this).prop("selected", true);

        if(size == 'Queen' || size == 'King' || size == 'Double' || size == 'Super King') {
          quiltCoverSet.setIncludes = 'Set includes: Quilt Cover(1), Pillowcase(2)';
        }else{
          quiltCoverSet.setIncludes = 'Set includes: Quilt Cover(1), Pillowcase(1)';
        }

        if(quiltCoverSet.selected) {
          updateSummary(quiltCoverSet, dataId);
        }

        if (quiltCoverSet.size && quiltCoverSet.color) {
          $(this).parents('.contentWrap').find('a.nxtBtn').addClass('enabled');
        }

      }

    });

  } else if($(this).attr('name').includes('Color')) {

    let color = option;
    let size;
    let variantOptions;
    let dataId = $(this).parents('.setContent').data('id');

    if($(this).parents('.setContent').attr('id') == 'set3Content' ) {

      let sizeWrapper = $(this).parents('.extraContent').find('.sizeWrapper');
      size = sizeWrapper.find('input[type=radio]').val();
      variantOptions = $(this).parents('.extraCont').find('select option');

    } else {

      let sizeWrapper = $(this).parents('.productSet').find('.sizeWrapper');
      size = sizeWrapper.find('input[type=radio]:checked').val();
      variantOptions = $(this).parents('.colorWrapper').siblings('.selectWrap').find('select option');

    }
    
    selectedVariantPoss1 = size.concat(' / ', color);
    selectedVariantPoss2 = color.concat(' / ', size);

    variantOptions.each(function() {

      if(($(this).data('title') == selectedVariantPoss1 || $(this).data('title') == selectedVariantPoss2) && $(this).parents('.setContent').attr('id') == 'set1Content') {

        bundleBuilder.previewImage = $(this).data('src');
        sheetSet.variantId  = $(this).val();
        sheetSet.imgSrc  = $(this).data('src');
        sheetSet.imgSrcSide  = $(this).data('src-side');
        sheetSet.imgSrcFront  = $(this).data('src-front');
        sheetSet.imgSrcSideQuilt  = $(this).data('src-side-quilt');
        sheetSet.imgSrcFrontQuilt  = $(this).data('src-front-quilt');
        sheetSet.productTitle  = $(this).data('product-title');
        sheetSet.url  = $(this).data('url');
        sheetSet.comparePrice  = $(this).data('compare-price');
        sheetSet.price  = $(this).data('price');
        sheetSet.color  = color;
        sheetSet.selected  = true;
        $(`.bundleHead #${dataId}`).attr('data-complete', 'yes');
        $(this).prop("selected", true);

        if(size == 'Queen' || size == 'King' || size == 'Double') {
          sheetSet.setIncludes = 'Set includes: Fitted Sheet(1), Flat Sheet(1), Pillowcase(2)';
        }else{
          sheetSet.setIncludes = 'Set includes: Fitted Sheet(1), Flat Sheet(1), Pillowcase(1)';
        }
        
        updateSummary(sheetSet, dataId);
        updateSlider(sheetSet);

        if (sheetSet.size && sheetSet.color) {
          $(this).parents('.contentWrap').find('a.nxtBtn').addClass('enabled');
        }

      } else if(($(this).data('title') == selectedVariantPoss1 || $(this).data('title') == selectedVariantPoss2) && $(this).parents('.setContent').attr('id') == 'set2Content') {

        bundleBuilder.previewImage = $(this).data('src');
        quiltCoverSet.productIndex  = $(this).parents('.productSet').data('tab-index');
        quiltCoverSet.variantId  = $(this).val();
        quiltCoverSet.imgSrc  = $(this).data('src');
        quiltCoverSet.imgSrcSide  = $(this).data('src-side');
        quiltCoverSet.imgSrcFront  = $(this).data('src-front');
        quiltCoverSet.productTitle  = $(this).data('product-title');
        quiltCoverSet.url  = $(this).data('url');
        quiltCoverSet.comparePrice  = $(this).data('compare-price');
        quiltCoverSet.price  = $(this).data('price');
        quiltCoverSet.color  = color;
        quiltCoverSet.selected  = true;
        $(`.bundleHead #${dataId}`).attr('data-complete', 'yes');
        $(this).prop("selected", true);

        if(size == 'Queen' || size == 'King' || size == 'Double' || size == 'Super King') {
          quiltCoverSet.setIncludes = 'Set includes: Quilt Cover(1), Pillowcase(2)';
        }else{
          quiltCoverSet.setIncludes = 'Set includes: Quilt Cover(1), Pillowcase(1)';
        }

        if (!$('img.sheet-set').hasClass('quilt-active')) {
          $('img.sheet-set').addClass('quilt-active');
          $('img.sheet-set.sheet-set-side').attr('src', sheetSet.imgSrcSideQuilt);
          $('img.sheet-set.sheet-set-front').attr('src', sheetSet.imgSrcFrontQuilt);
        }

        updateSummary(quiltCoverSet, dataId);
        updateSlider(quiltCoverSet);
        updatelabelImg(quiltCoverSet);

        if (quiltCoverSet.size && quiltCoverSet.color) {
          $(this).parents('.contentWrap').find('a.nxtBtn').addClass('enabled');
        }

      } else if(($(this).data('title') == selectedVariantPoss1 || $(this).data('title') == selectedVariantPoss2) && $(this).parents('.setContent').attr('id') == 'set3Content') {

        let qtyField = $(this).parents('.productSet').find('input.quantity')
        
        bundleBuilder.previewImage = $(this).data('src');
        extra.productIndex  = $(this).parents('.productSet').data('tab-index');
        extra.variantId  = $(this).val();
        extra.imgSrc = $(this).data('src');
        extra.imgSrcSide  = $(this).data('src-side');
        extra.imgSrcFront  = $(this).data('src-front');
        extra.productTitle  = $(this).data('product-title');
        extra.url  = $(this).data('url');
        extra.comparePrice  = $(this).data('compare-price');
        extra.price  = $(this).data('price');
        extra.color = color;
        extra.size = size;
        extra.quantity = +qtyField.val();
        extra.selected  = true;
        $(`.bundleHead #${dataId}`).attr('data-complete', 'yes');
        $(this).prop("selected", true);

        updateSummary(extra, dataId);
        updateSlider(extra);
        updatelabelImg(extra);

      }

    });

  }
}

function updateSummary(product, setId) {
  
  let productIndex = '';

  if (product.productIndex != undefined) {
    productIndex = product.productIndex;
  }

  if (productIndex > 1 && product.quantity === 1 && product.item.includes('extra')) {
    if (bundleItemsWrapper.prev().length === 0) {
      let singleText = $('<div class="singleExtraText">Note: Our Oxford Sham (or European Sham) Pillowcases are sold as singles. If you want a Pair of Two, please manually add another item to your bundle below.</div>');

      singleText.insertBefore(bundleItemsWrapper);
    }
  } else {
    $('.singleExtraText').remove();
  }

  if (product.selected && bundleItemsWrapper.find(`.${product.title.toLowerCase().replace(new RegExp(' ', 'g'), '-')}Item`).length == 0) {

    bundleItemsWrapper.append(`<div class="bundleItemWrap ${product.title.toLowerCase().replace(new RegExp(' ', 'g'), '-')}Item" data-set="${setId}" data-item="${product.item}${productIndex}">
                                <div class="itemImage">
                                  <img src="${product.imgSrc}" width="100" height="100">
                                </div>
                                <div class="itemInfo">
                                  <div class="itemTitle">${product.quantity} x ${product.productTitle}</div>
                                  <div class="itemColor">
                                    <span class="color ${product.color.toLowerCase().replace(new RegExp(' ', 'g'), '-')}" style="background-image:url('${product.imgSrc}')"></span>
                                    <span class="colorName">${product.color}</span>
                                  </div>
                                  <div class="material">100% Bamboo</div>
                                  <div class="size">${product.size}</div>
                                  <div class="inclusions">${product.setIncludes}</div>
                                  <div class="edit">
                                    <a href="#">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <path d="M0 9.20865V11.5H2.49965L9.87196 4.74205L7.37231 2.4507L0 9.20865ZM11.805 2.97007C12.065 2.73177 12.065 2.34683 11.805 2.10853L10.2452 0.678725C9.98528 0.440425 9.56534 0.440425 9.30537 0.678725L8.08554 1.7969L10.5852 4.08825L11.805 2.97007Z" fill="#A8A8A8"/>
                                      </svg>
                                      <span class="text">Edit</span>
                                    </a>
                                  </div>
                                </div> 
                              </div>`);

  } else {

    bundleItemsWrapper.find(`.${product.title.toLowerCase().replace(new RegExp(' ', 'g'), '-')}Item`).replaceWith(`<div class="bundleItemWrap ${product.title.toLowerCase().replace(new RegExp(' ', 'g'), '-')}Item" data-set="${setId}" data-item="${product.item}${productIndex}">
                                                        <div class="itemImage">
                                                          <img src="${product.imgSrc}" width="100" height="100">
                                                        </div>
                                                        <div class="itemInfo">
                                                          <div class="itemTitle">${product.quantity} x ${product.productTitle}</div>
                                                          <div class="itemColor">
                                                            <span class="color ${product.color.toLowerCase().replace(new RegExp(' ', 'g'), '-')}" style="background-image:url('${product.imgSrc}')"></span>
                                                            <span class="colorName">${product.color}</span>
                                                          </div>
                                                          <div class="material">100% Bamboo</div>
                                                          <div class="size">${product.size}</div>
                                                          <div class="inclusions">${product.setIncludes}</div>
                                                          <div class="edit">
                                                          <a href="#">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                              <path d="M0 9.20865V11.5H2.49965L9.87196 4.74205L7.37231 2.4507L0 9.20865ZM11.805 2.97007C12.065 2.73177 12.065 2.34683 11.805 2.10853L10.2452 0.678725C9.98528 0.440425 9.56534 0.440425 9.30537 0.678725L8.08554 1.7969L10.5852 4.08825L11.805 2.97007Z" fill="#A8A8A8"/>
                                                            </svg>
                                                            <span class="text">Edit</span>
                                                          </a>
                                                        </div>
                                                        </div>
                                                      </div>`);

  }

}

function updateSlider(product) {

  $('.itemsImagesSliderMainWrap').find('.sliderLoader').css('display', 'flex');

  let alreadyExist = $('.bundlePreviewImg .itemsImagesSliderWrap').find(`img.${product.title.toLowerCase().replace(new RegExp(' ', 'g'), '-')}-side`);
  let sideImgsWrap = $('.bundlePreviewImg .itemsImagesSliderWrap .itemsImgSliderSide');
  let frontImgsWrap = $('.bundlePreviewImg .itemsImagesSliderWrap .itemsImgSliderFront');

  if (alreadyExist.length == 0) {

    sideImgsWrap.append(`<img class="${product.title.toLowerCase().replace(new RegExp(' ', 'g'), '-')}-side ${product.title.toLowerCase().replace(new RegExp(' ', 'g'), '-')} active" src="${product.imgSrcSide}">`);
    frontImgsWrap.append(`<img class="${product.title.toLowerCase().replace(new RegExp(' ', 'g'), '-')}-front ${product.title.toLowerCase().replace(new RegExp(' ', 'g'), '-')} active" src="${product.imgSrcFront}">`);
    sideImgsWrap.find(`img.${product.title.toLowerCase().replace(new RegExp(' ', 'g'), '-')}`).siblings().removeClass('active');
    frontImgsWrap.find(`img.${product.title.toLowerCase().replace(new RegExp(' ', 'g'), '-')}`).siblings().removeClass('active');

  } else {

    if (alreadyExist.hasClass('quilt-active')) {

      sideImgsWrap.find(`img.${product.title.toLowerCase().replace(new RegExp(' ', 'g'), '-')}-side`).attr('src', product.imgSrcSideQuilt).addClass('active');
      frontImgsWrap.find(`img.${product.title.toLowerCase().replace(new RegExp(' ', 'g'), '-')}-front`).attr('src', product.imgSrcFrontQuilt).addClass('active');
      sideImgsWrap.find(`img.${product.title.toLowerCase().replace(new RegExp(' ', 'g'), '-')}`).siblings().removeClass('active');
      frontImgsWrap.find(`img.${product.title.toLowerCase().replace(new RegExp(' ', 'g'), '-')}`).siblings().removeClass('active');

    } else {

      sideImgsWrap.find(`img.${product.title.toLowerCase().replace(new RegExp(' ', 'g'), '-')}-side`).attr('src', product.imgSrcSide).addClass('active');
      frontImgsWrap.find(`img.${product.title.toLowerCase().replace(new RegExp(' ', 'g'), '-')}-front`).attr('src', product.imgSrcFront).addClass('active');
      sideImgsWrap.find(`img.${product.title.toLowerCase().replace(new RegExp(' ', 'g'), '-')}`).siblings().removeClass('active');
      frontImgsWrap.find(`img.${product.title.toLowerCase().replace(new RegExp(' ', 'g'), '-')}`).siblings().removeClass('active');

    }

  }

  let container = $('.itemsImagesSliderMainWrap');

  onImagesLoaded(container, function() {
    $('.itemsImagesSliderMainWrap').find('.sliderLoader').hide();
  });

}

function onImagesLoaded(container, event) {
  let images = container.find("img");
  let loaded = images.length;
  for (var i = 0; i < images.length; i++) {
    if (images[i].complete) {
      loaded--;
    } else {
      images[i].addEventListener("load", function() {
        loaded--;
        if (loaded == 0) {
          event();
        }
      });

      images[i].addEventListener("error", function() {
        loaded--;
        console.log('Error loading image.');
        if (loaded == 0) {
          event();
        }
      });
    }
    if (loaded == 0) {
      event();
    }
  }

  return;
}

function updatelabelImg(product) {
  
  let labelContainer;

  if(product.item.includes('quilt')) {
    labelContainer = $('#set2Content .stylesProducts');
  } else {
    labelContainer = $('#set3Content .stylesProducts');
  }

  let productSet = labelContainer.find(`.productSet[data-tab-index='${product.productIndex}']`);

  productSet.find('label img').attr('src', `${product.imgSrc.replace('.png', '_200x.png').replace('.jpg', '_200x.jpg')}`);

}

function changeBorderColor() {

  $(this).parents('.colorOptions').find('.border-black').removeClass('border-black');
  $(this).parent().addClass('border-black');

}

function updateColor(color) {

  $(this).parents('.colorOptions').prev().find('.selectedColor').html(color);

}